import React from 'react';
import { Box, Typography, CircularProgress, useTheme } from '@mui/material';
import { formatDateTime } from 'components/shared';

// Message thread pane: renders the selected conversation's messages.
// Real messages are supplied via props by the Inbox page.
const ChatBox = ({ messages = [], loading = false }) => {
  const theme = useTheme();

  return (
    <Box sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
      {loading ? (
        <Box display="flex" justifyContent="center" p={4}>
          <CircularProgress size={28} />
        </Box>
      ) : messages.length === 0 ? (
        <Typography variant="body2" color="text.secondary" align="center" p={4}>
          No messages yet.
        </Typography>
      ) : (
        messages.map((m, idx) => {
          const isAdmin = m?.sender === 'admin';
          const bubbleBg = isAdmin
            ? theme.palette.primary.main
            : theme.palette.neutral?.[300] || theme.palette.grey[300];
          return (
            <Box
              key={m?._id || idx}
              sx={{
                display: 'flex',
                justifyContent: isAdmin ? 'flex-end' : 'flex-start',
                mb: 1.5,
              }}
            >
              <Box
                sx={{
                  maxWidth: '70%',
                  p: 1.25,
                  borderRadius: 2,
                  bgcolor: bubbleBg,
                  color: isAdmin
                    ? theme.palette.primary.contrastText
                    : theme.palette.getContrastText(bubbleBg),
                }}
              >
                <Typography variant="caption" fontWeight="bold">
                  {m?.senderName || (isAdmin ? 'You' : 'Customer')}
                </Typography>
                <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                  {m?.body || ''}
                </Typography>
                <Typography variant="caption" sx={{ display: 'block', opacity: 0.7, mt: 0.5 }}>
                  {formatDateTime(m?.createdAt)}
                </Typography>
              </Box>
            </Box>
          );
        })
      )}
    </Box>
  );
};

export default ChatBox;
